import { render } from "./BannerTwoView.vue?vue&type=template&id=3c45c4c8&scoped=true"
import script from "./BannerTwoView.vue?vue&type=script&lang=js"
export * from "./BannerTwoView.vue?vue&type=script&lang=js"

import "./BannerTwoView.vue?vue&type=style&index=0&id=3c45c4c8&lang=scss&scoped=true"

import exportComponent from "D:\\software\\phpEnv\\www\\hkz-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c45c4c8"]])

export default __exports__